import Prism from "prismjs";
import "prismjs/components/prism-python";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-json";
import type { JupyterNotebook } from "server/corsproxy/remoteContent/api";

const HTML_ENTITIES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export const escapeHtml = (value: string) =>
  value.replace(/[&<>"']/g, (character) => HTML_ENTITIES[character]);

export const joinNotebookSource = (source?: string | string[]): string => {
  if (Array.isArray(source)) return source.join("");
  return source || "";
};

export const getNotebookLanguage = (notebook: JupyterNotebook): string => {
  const language =
    notebook.metadata?.language_info?.name ||
    notebook.metadata?.kernelspec?.language ||
    "python";
  return language.toLowerCase();
};

export const highlightNotebookCode = (
  code: string,
  language: string,
): string => {
  const grammar = Prism.languages[language] || Prism.languages.python;
  try {
    return Prism.highlight(code, grammar, language);
  } catch {
    return escapeHtml(code);
  }
};
